import React from 'react';

const CartItem = ({ item, onRemove }) => {
  return (
    <div className="flex items-center justify-between py-3 border-b border-gray-100">
      <div className="flex items-center">
        <span className="text-2xl mr-3">{item.emoji}</span>
        <div>
          <h4 className="font-medium text-gray-800">{item.name}</h4>
          <p className="text-sm text-gray-500">${item.price}</p>
        </div>
      </div>
      <button 
        onClick={() => onRemove(item.id)}
        className="text-red-500 hover:text-red-700 transition-colors"
      >
        ×
      </button>
    </div>
  );
};

export default CartItem;